// eslint-disable-next-line import/prefer-default-export
export const currentLocale = window.__INITIAL_STATE__.locale || 'zh-CN';

export const OA_LOGIN_LOCALE = currentLocale.replace('-', '_');
